import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.png';
import { userSession, orderApi } from '../services';

function StartPage({ onNavigate }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showUncheckoutWarning, setShowUncheckoutWarning] = useState(false);
  const [pendingOrder, setPendingOrder] = useState(null);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    checkLoginStatus();
  }, []);

  const checkLoginStatus = () => {
    const token = localStorage.getItem('token');
    const userInfoData = localStorage.getItem('user_info');
    
    setIsLoggedIn(!!token);
    
    if (userInfoData) {
      try {
        const userData = JSON.parse(userInfoData);
        setUserInfo(userData);
      } catch (error) {
        console.error('Error parsing user info:', error);
        setUserInfo(null);
      }
    } else {
      setUserInfo(null);
    }
  };

  const checkForUncheckoutOrders = async () => {
    try {
      const response = await orderApi.getOrdersByMobile();
      
      if (response.ok && Array.isArray(response.payload)) {
        // Find orders that are checked in but not checked out (status 0 = checked in)
        const uncheckoutOrders = response.payload.filter(order => order.status === 0);
        
        if (uncheckoutOrders.length > 0) {
          // Get the most recent uncheckout order
          const mostRecentOrder = uncheckoutOrders.sort((a, b) => 
            new Date(b.created_datetime || b.created_at || b.date) - 
            new Date(a.created_datetime || a.created_at || a.date)
          )[0];
          
          setPendingOrder(mostRecentOrder);
          setShowUncheckoutWarning(true);
          return true; // Has uncheckout order
        }
      }
      return false; // No uncheckout orders
    } catch (error) {
      console.error('Error checking for uncheckout orders:', error);
      return false;
    }
  };

  const handleCheckin = async () => {
    if (isLoggedIn) {
      // Check for uncheckout orders first
      const hasUncheckoutOrder = await checkForUncheckoutOrders();
      
      if (hasUncheckoutOrder) {
        // Don't proceed with checkin, warning popup will be shown
        return;
      }
      
      // User is logged in, auto-fill info and go to order page
      const userInfo = localStorage.getItem('user_info');
      if (userInfo) {
        try {
          const userData = JSON.parse(userInfo);
          // Save user session for checkout flow
          userSession.saveSession({
            phone: userData.username, // Using username as phone number
            name: userData.name,
            checkinTime: new Date().toISOString(),
          });
          
          // Navigate directly to order page
          onNavigate('/order');
        } catch (error) {
          console.error('Error parsing user info:', error);
          // Fallback to normal checkin flow
          onNavigate('/checkin');
        }
      } else {
        // No user info found, go to normal checkin
        onNavigate('/checkin');
      }
    } else {
      // User not logged in, go to normal checkin flow
      onNavigate('/checkin');
    }
  };

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    // Clear all localStorage data
    localStorage.removeItem('token');
    localStorage.removeItem('user_info');
    localStorage.removeItem('tth_user_session');
    
    // Update state
    setIsLoggedIn(false);
    setUserInfo(null);
    setShowLogoutConfirm(false);
    
    // Optionally show success message
    console.log('Đăng xuất thành công');
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  const handleViewOrderDetail = () => {
    if (pendingOrder) {
      onNavigate(`/order-detail/${pendingOrder.order_id || pendingOrder.id}`);
    }
    setShowUncheckoutWarning(false);
  };

  const handleContinueCheckin = () => {
    setShowUncheckoutWarning(false);
    setPendingOrder(null);
    
    // Proceed with normal checkin flow
    const userInfo = localStorage.getItem('user_info');
    if (userInfo) {
      try {
        const userData = JSON.parse(userInfo);
        userSession.saveSession({
          phone: userData.username,
          name: userData.name,
          checkinTime: new Date().toISOString(),
        });
        onNavigate('/order');
      } catch (error) {
        console.error('Error parsing user info:', error);
        onNavigate('/checkin');
      }
    } else {
      onNavigate('/checkin');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', width: 320, minHeight: 600, borderRadius: 8, padding: 32, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        
        {/* User Info Section */}
        <div>
          <img src={logo} alt="logo" style={{ height: 100 }} />
        </div>
        {isLoggedIn && userInfo && (
          <div style={{ 
            width: '100%', 
            padding: 16, 
            marginBottom: 24,
            textAlign: 'center',
          }}>
            <div style={{ 
              fontSize: 16, 
              fontWeight: 600, 
              color: '#5b6754',
              marginBottom: 50,
              marginTop: 0
            }}>
              Xin chào, {userInfo.name}!
            </div>
          </div>
        )}

        
        <button style={btnStyle} onClick={handleCheckin}>Check-in</button>
        {/* <button style={btnStyle} onClick={() => onNavigate('checkout')}>Check-out</button> */}
		    {isLoggedIn && <button style={btnStyle} onClick={() => onNavigate('order-history')}>Lịch sử đơn hàng</button> }
        {<button style={btnStyle} onClick={() => {
          if(isLoggedIn){
            onNavigate('points')
          }else{
            onNavigate('login')
          }
        }}>Điểm tích lũy</button>}
        {!isLoggedIn ? (
          <>
            <button style={btnStyle} onClick={() => onNavigate('login')}>Đăng nhập</button>
            <button style={btnStyle} onClick={() => onNavigate('register')}>Đăng ký</button>
          </>
        ) : (
          <button style={btnStyle} onClick={handleLogout}>Đăng xuất</button>
        )}
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 12,
            padding: 24,
            width: 280,
            textAlign: 'center',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
          }}>
            <h3 style={{ 
              marginBottom: 16, 
              fontSize: 18, 
              fontWeight: 600, 
              color: '#5b6754' 
            }}>
              Xác nhận đăng xuất
            </h3>
            <p style={{ 
              marginBottom: 24, 
              fontSize: 14, 
              color: '#666',
              lineHeight: 1.5
            }}>
              Bạn có chắc chắn muốn đăng xuất khỏi tài khoản?
            </p>
            <div style={{ display: 'flex', gap: 12 }}>
              <button
                onClick={cancelLogout}
                style={{
                  flex: 1,
                  height: 40,
                  background: 'transparent',
                  color: '#666',
                  border: '1px solid #ddd',
                  borderRadius: 20,
                  fontSize: 14,
                  cursor: 'pointer',
                  fontFamily: 'NeueEinstellung'
                }}
              >
                Hủy
              </button>
              <button
                onClick={confirmLogout}
                style={{
                  flex: 1,
                  height: 40,
                  background: '#ff4444',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 20,
                  fontSize: 14,
                  cursor: 'pointer',
                  fontFamily: 'NeueEinstellung',
                  fontWeight: 500
                }}
              >
                Đăng xuất
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Uncheckout Warning Modal */}
      {showUncheckoutWarning && pendingOrder && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 12,
            padding: 24,
            width: 320,
            textAlign: 'center',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
          }}>
            <div style={{ 
              fontSize: 18, 
              fontWeight: 600, 
              color: '#ff4444',
              marginBottom: 16
            }}>
              ⚠️ Cảnh báo
            </div>
            <p style={{ 
              marginBottom: 16, 
              fontSize: 14, 
              color: '#666',
              lineHeight: 1.5
            }}>
              Bạn có đơn hàng chưa check-out. Vui lòng hoàn thành đơn hàng trước.
            </p>
            
            {pendingOrder.list_products && pendingOrder.list_products.length > 0 && (
              <div style={{
                background: '#f8f8f8',
                borderRadius: 8,
                padding: 12,
                marginBottom: 16,
                textAlign: 'left'
              }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>
                  Đơn hàng #{pendingOrder.order_id || pendingOrder.id}:
                </div>
                {pendingOrder.list_products.slice(0, 2).map((item, idx) => (
                  <div key={idx} style={{ fontSize: 13, color: '#666' }}>
                    • {item.name} x{item.quantity}
                  </div>
                ))}
                {pendingOrder.list_products.length > 2 && (
                  <div style={{ fontSize: 13, color: '#888' }}>
                    ... và {pendingOrder.list_products.length - 2} sản phẩm khác
                  </div>
                )}
              </div>
            )}
            
            <div style={{ display: 'flex', gap: 8 }}>
              <button
                onClick={handleViewOrderDetail}
                style={{
                  flex: 1,
                  height: 40,
                  background: '#5b6754',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 20,
                  fontSize: 14,
                  cursor: 'pointer',
                  fontFamily: 'NeueEinstellung',
                  fontWeight: 500
                }}
              >
                Xem chi tiết
              </button>
             
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const btnStyle = {
  width: 180,
  height: 48,
  background: '#5b6754',
  color: '#fff',
  border: 'none',
  borderRadius: 24,
  fontSize: 18,
  margin: '12px 0',
  cursor: 'pointer',
  fontWeight: 400,
  fontFamily: 'NeueEinstellung',
};

export default StartPage; 